import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styled from 'styled-components';
import { TextField } from '@mui/material';

const LoginContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

const LoginForm = styled.div`
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    width: 300px;
`;

const SubmitButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #6e8fbd;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #5a7ca1;
    }
`;

const Title = styled.h2`
    color: #333;
    text-align: center;
    margin-bottom: 20px;
`;

const InputFieldWrapper = styled.div`
    position: relative;
    margin: 10px 0;
`;

const InputField = styled.input`
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;

    &:focus {
        border-color: #6e8fbd;
        outline: none;
    }

    &:read-only {
        background-color: #f2f2f2;
        color: #888;
        cursor: not-allowed;
    }
`;

const EyeButton = styled.button`
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    border: none;
    background: none;
    cursor: pointer;
    font-size: 18px;
    color: #6e8fbd;
`;

const ErrorText = styled.p`
    color: red;
    text-align: center;
    font-size: 14px;
`;

const SuccessText = styled.p`
    color: green;
    text-align: center;
    font-size: 14px;
`;

export default function ResetPage() {
  const navigate = useNavigate();

  const [code, setCode] = useState('')
  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');

const [form, setForm] = useState({
    email: '',
    newPassword: '',
    repeatNewPassword: ''
});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setCode(params.get('code'));
    setForm(prev => ({ ...prev, email: params.get('email') || '' }));
  }, []);

  const validate = () => {
    let errs = {};

    // password
    if (!form.newPassword) {
      errs.newPassword = "Password is required";
    } else if (form.newPassword.length < 3) {
      errs.newPassword = "Password must be at least 3 characters";
    } else if (form.newPassword.length > 64) {
      errs.newPassword = "Password must be max 64 characters";
    }

    // confirm password
    if (form.newPassword) {
      if (!form.repeatNewPassword) {
        errs.repeatNewPassword = "Please confirm password";
      } else if (form.newPassword !== form.repeatNewPassword) {
        errs.repeatNewPassword = "Passwords do not match";
      }
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!validate()) {
        return;
    }
    axios.post(`api/auth/password/confirm`, {
        newPassword: form.newPassword,
        code
    }).then(() => {
      setSuccess('Password has been reset successfully. Redirecting to login...');
      navigate('/login');
    }).catch(error => {setError(error.response.data.message)});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors({ ...errors, [name]: null });
  };

  return (
    <LoginContainer>
        <LoginForm>
            <Title>Create New Password</Title>
            <form onSubmit={handleReset}>
                <InputFieldWrapper>
                    <InputField
                        type="text"
                        placeholder="Email"
                        value={form.email}
                        readOnly
                    />
                </InputFieldWrapper>
                <InputFieldWrapper>
                    <TextField
                        label="Password"
                        variant="filled"
                        name="newPassword"
                        type={showPassword ? 'text' : 'password'}
                        value={form.newPassword}
                        onChange={handleChange}
                        fullWidth
                        error={!!errors.newPassword}
                        helperText={errors.newPassword}
                    />
                </InputFieldWrapper>
                <InputFieldWrapper>
                    <TextField
                        label="Confirm Password"
                        variant="filled"
                        name="repeatNewPassword"
                        type={showPassword ? 'text' : 'password'}
                        value={form.repeatNewPassword}
                        onChange={handleChange}
                        disabled={!form.newPassword}
                        fullWidth
                        error={!!errors.repeatNewPassword}
                        helperText={errors.repeatNewPassword}
                    />
                    <EyeButton
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? '🙈' : '👁️'}
                    </EyeButton>
                </InputFieldWrapper>
                <SubmitButton type="submit">Submit</SubmitButton>
            </form>
            {error && <ErrorText>{error}</ErrorText>}
            {success && <SuccessText>{success}</SuccessText>}
        </LoginForm>
    </LoginContainer>
);
}
